import React, { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { theme } from "../../Assets/Theme/theme";
import CartItems from "../../Components/MyCart/CartItems";
import { experiencesData } from "../../Services/dymmyData";
import Card from "../../Components/Common/Card";
import Heading from "../../Components/Common/Heading";
import Container from "../../Components/Layout/Container";
import CardsSlider from "../../Components/Common/CardSlider";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import { useCart } from "../../Services/CartContext";
import { CurrencyContext } from "../../Services/CurrencyContext";
import { BASE_URL } from "../../Assets/Constants";
import axios from "axios";
import { toast } from "react-toastify";

function MyCart() {
  const [experiencesData, setExperiencesData] = useState([]);
  const { currency } = useContext(CurrencyContext);
  const { cart } = useCart();

  const fetchExperiences = async (selectedCurrency) => {
    try {
      const loginData = JSON.parse(localStorage.getItem("loginData"));
      const token = loginData?.token;

      const response = await axios.post(
        `${BASE_URL}/user/experiences`,
        { currencysymbol: selectedCurrency },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (Array.isArray(response.data?.data)) {
        setExperiencesData(response.data.data);
      } else {
        console.error("Unexpected data format: `data` is not an array");
        setExperiencesData([]);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } 
  };

  useEffect(() => {
    fetchExperiences(currency);
  }, [currency]);
  
  return (
    <>
      <Navbar currency={currency} />{" "}
      <Box>
        <Container>
          <Box textAlign={"center"} my={3}>
            <Heading label={"My Cart"} />
          </Box>
          {cart?.length <= 0 && <Box
            sx={{
              textAlign: "center",
              color: "gray",
              fontSize: "0.9rem",
              marginTop: "2rem",
            }}
          >
            No data available
          </Box>
         
          }
          <CartItems data={cart} />
          <Box mt={10}>
            <Heading label={"Related Experiences"} />
          </Box>

          <CardsSlider data={experiencesData} />
        </Container>
      </Box>
      <Footer />
    </>
  );
}

export default MyCart;
